export default "__VITE_ASSET__CBWo_B1q__"